import { Component, effect, ElementRef, EventEmitter, HostListener, input, OnInit, output, QueryList, ViewChild, ViewChildren, TemplateRef, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { HttpService } from 'src/app/services/http.service';
import { ControlPoint, ControlPointVib, VibrationType } from '../../bo/controlPoint';
import { ProprieteAffichee } from '../../bo/proprieteAffichee';
import { FonctionsService } from '../../services/fonctions-partagees.service';
import { DonneesVibrationModaleComponent } from '../donnees-vibration-modale/donnees-vibration-modale.component';
import { Chart, ChartConfiguration, ChartType } from 'src/app/utils/chart-config';
import { VibrationsChart } from '../../bo/vibrationsForChart/vibrationsChart';
import { UtilisateurService } from '../../services/utilisateur.service';
import { ChartDataFft } from 'src/app/bo/vibrationsForChart/chartDataFft';
import { VibrationsChartChannel } from 'src/app/bo/vibrationsForChart/vibrationsChartChannel';
import { Vibration } from 'src/app/bo/vibration';
import { DirectoryType } from 'src/app/bo/fichier';
import { convertLegacyDataset, convertLegacyScaleOptions } from '../../utils/chartjs-migration.utils';
import { EditNote, EditNotes } from 'src/app/bo/vibrationsForChart/editNotes';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
  selector: 'app-donnees-vibration',
  templateUrl: './donnees-vibration.component.html',
  styleUrls: ['./donnees-vibration.component.scss'],
  standalone: false
})
export class DonneesVibrationComponent implements OnInit{
  @ViewChild('modalExport') modalExport: ModalDirective;
  @ViewChildren('input') inputs: QueryList<ElementRef>;
  tabDonneesVibrationNewModel = input<VibrationsChart[]>();
  tabDonneesVibrationOldModel = input<Vibration[]>();
  proprietesAffichees = input<ProprieteAffichee[]>();
  tabControlPoints = input<ControlPoint[]>();
  donneesChargees = input<boolean>();
  rechargerDonnees = output<boolean>();

  tabControlPointsForBtn = signal<ControlPointVib[]>([]);
  tabControlPointsVibNewModel = signal<ControlPointVib[]>([]);
  tabControlPointsVibOldModel = signal<ControlPointVib[]>([]);

  ponderationTypes:string[] = ['Ponderation FR', ''];
  selectedPonderationType = 'Ponderation FR';

  modalModif: BsModalRef;
  modalNotes: BsModalRef;

  siteId: number;
  projetId: number;
  tirId: number;
  minMax = signal<number[]>([]);
  activeTab = signal(0);
  activeControlPointIndex = signal<number>(undefined);

  activeVibrationsNewModel = signal<VibrationsChart>(undefined);
  activeVibrationsOldModel = signal<Vibration>(undefined);

  activeControlPoint: ControlPoint;
  channelNames = ['VIBRATION.VERTICAL', 'VIBRATION.LONGITUDE', 'VIBRATION.TRANSVERSE'];
  valueTypes = ['mm/s', 'mm/s', 'mm/s', 'Pa'];
  chartWindow = signal(0);
  chart: Chart;
  chartDataFft = signal<ChartDataFft[]>([]);
  notes = signal<EditNotes>(undefined);
  notesEdit = signal<EditNotes>(undefined);

  hauteur = signal(0);
  


  constructor(
    private readonly modalService: BsModalService,
    private readonly http: HttpService,
    private readonly route: ActivatedRoute,
    private readonly fonctionsService: FonctionsService,
    private readonly el: ElementRef,
    private readonly utilService: UtilisateurService,
  ) {
    effect(() => {

      this.tabDonneesVibrationNewModel();
      this.tabDonneesVibrationOldModel();
      this.tabControlPoints();
      this.refresh();
    });
  }


  ngOnInit() {
    this.route.params.subscribe(params => {
      this.siteId = params.id;
      this.projetId = params.projectId;
    });
    this.route.queryParams.subscribe(params => {
      this.tirId = params.blastId;
    });
    this.setTabControlPointsForBtns();

    this.modalService.onHide.subscribe((val: string) => {
      if(val === 'vibAdded'|| val === 'vibDeleted'){
        this.activeControlPointIndex.set(undefined);
        this.rechargerDonnees.emit(true)
        this.http.delete('VibrationsMongo/' + this.utilService.currentSite().siteId + '/DeleteTempVibrationsFiles').subscribe();
      }else if(val === 'filesSended'){
        this.http.delete('VibrationsMongo/' + this.utilService.currentSite().siteId + '/DeleteTempVibrationsFiles').subscribe();
      }
    });
  }

  ngAfterViewInit(): void {
    if (this.activeVibrationsNewModel() !== undefined) {
      setTimeout(() => {
        this.drawingVibrations();
      }, 0);
    }
  }

  private refresh() {
    this.fonctionsService.loading_screen(true);
    this.activeVibrationsNewModel.set(undefined);
    this.activeVibrationsOldModel.set(undefined);
    this.setTabControlPointsForBtns();
        
      setTimeout(() => {
        this.drawingVibrations();
        this.fonctionsService.loading_screen(false);
      }, 0);
  }

  protected ouvrirModaleAdd() {
    let initialState;
      initialState = {
        controlPoints: this.tabControlPoints(),
        tirId: this.tirId,
        vibrationNewModel: undefined,
        estModifValue: false,
        siteId: this.siteId,
        tabDonneesVibrationNewModel: this.tabDonneesVibrationNewModel()
      }
    this.modalModif = this.modalService.show(DonneesVibrationModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, class: 'modal-xl vibration-modal', initialState });
  }

  protected ouvrirModaleModif() {
    let initialState;
    if (this.activeVibrationsNewModel() !== undefined) {
      initialState = {
        isNewValue: true,
        controlPoints: this.tabControlPoints(),
        tirId: this.tirId,
        vibrationNewModel: this.activeVibrationsNewModel(),
        tabDonneesVibrationNewModel: this.tabDonneesVibrationNewModel(),
        estModifValue: true,
        siteId: this.siteId,
        activeControlPointValue: this.tabControlPoints().filter(f => f.controlPointId === this.activeVibrationsNewModel().header.controlPointId)[0]
      }}
      else if(this.activeVibrationsOldModel() !== undefined){
        initialState = {
          isNewValue: false,
          controlPoints: this.tabControlPoints(),
          tirId: this.tirId,
          vibrationOldModel: this.activeVibrationsOldModel(),
          tabDonneesVibrationNewModel: this.tabDonneesVibrationNewModel(),
          estModifValue: true,
          siteId: this.siteId,
          activeControlPointValue: this.tabControlPoints().filter(f => f.controlPointId === this.activeVibrationsOldModel().controlPointId)[0]
        }
      }
      this.modalModif = this.modalService.show(DonneesVibrationModaleComponent, { backdrop: true, ignoreBackdropClick: true, keyboard: false, class: 'modal-xl vibration-modal', initialState });
    }

  private drawingVibrations() {
    this.hauteur.set(100 / 4);
    if (this.activeVibrationsNewModel() === undefined) return;
    this.minMax.set(this.findMinMax(this.activeVibrationsNewModel()));
    this.activeVibrationsNewModel().channels.forEach((value, index, array) => {
      if (!this.checkChannelData(value)) {
        this.drawingChannel(index, this.activeVibrationsNewModel());
      }
    });
  }

  private drawingChannel(index: number, vibrations: VibrationsChart) {
    let canvas = <HTMLCanvasElement>this.el.nativeElement.querySelector('#canvas-' + index);
    let ctx = canvas.getContext('2d')
    // create array with values for the x axis
    let array_for_label = [];
    vibrations.channels[index].value.forEach((value, index) => {
      array_for_label[index] = index;
    });
    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: array_for_label,
        datasets: [{
          label:'Channel #' + (index + 1),
          data: vibrations.channels[index].value,
          fill: false,
          tension: 0.1,
          borderWidth: 1,
          borderColor: 'rgb(153,0,77)',
          backgroundColor: 'white'
        }],
      },
      options: {
        elements: {
          point: {
            radius: 0
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false,
            labels: {
              boxWidth: 0
            }
          }
        },
        scales: {
          x: {
            grid: {
              tickLength: 3
            },
            ticks: {
              maxTicksLimit: vibrations.channels.length,
              callback: function (value, index, ticks) {
                return Math.round(index / 2048) + 's';
              },
              padding: 0
            },
            display: true,
          },
          y: {
            min: (vibrations.channels.length === 3 || index < vibrations.channels.length - 1) ? this.minMax()[0] : this.minMax()[2],
            max: (vibrations.channels.length === 3 || index < vibrations.channels.length - 1) ? this.minMax()[1] : this.minMax()[3],
            suggestedMin: 0,
            beginAtZero: true,
            ticks: {
              stepSize: 0.5,
            },
          }
        }
      }
    });
  }

  private drawingFFT(vibrations: VibrationsChart) {
    if (this.chart) 
    this.chart.destroy();

    this.setChartDataFft(vibrations);

    if(this.chartDataFft() == undefined) return;

    let canvas = <HTMLCanvasElement>this.el.nativeElement.querySelector('#canvas-fft');
    let ctx = canvas.getContext('2d')
    // scale hz to 150hz
    let array_for_labelX = [];
    for (let index = 0; vibrations.fftsHz.length; index++) {
      array_for_labelX[index] = vibrations.fftsHz[index];
      
      if (vibrations.fftsHz[index] >= 150) break;
    }
    //create chart
    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: array_for_labelX,
        datasets: this.chartDataFft(),
      },
      options: {
        plugins: {
          tooltip: {
            enabled: false
          },
          legend: {
            display: true,
            labels: {
              color: 'black'
            }
          }
        },
        hover: {mode: null as any},
        elements: {
          point: {
            radius: 0
          },
        },
        responsive: true,
        maintainAspectRatio: true,
        scales: {
          x: {
            grid: {
              tickLength: 3
            },
            ticks: {
              maxRotation: 90,
              minRotation: 90,
              maxTicksLimit: 20,
              callback: function (value, index, ticks) {
                return Math.round(Number(value)) + ' Hz';
              },
              padding: 0
            },
            display: true,
          }
        }
      }
    });
  }

  private findMinMax(vibration: VibrationsChart): number[] {
    let minMax = [0, 0, 0, 0];
    vibration.channels.forEach((value, index, array) => {
      if ( vibration.channels.length === 3 || index < vibration.channels.length - 1) {
        if (value.minValue < minMax[0]) minMax[0] = value.minValue;
        if (value.maxValue > minMax[1]) minMax[1] = value.maxValue;
      } else {
        // this is last channel
        minMax[2] = value.minValue;
        minMax[3] = value.maxValue;
      }
    })
    return minMax;
  }

  protected changerTab(id: number, type: VibrationType, index: number) {
    this.activeControlPointIndex.set(index);
    this.activeVibrationsNewModel.set(undefined);
    this.activeVibrationsOldModel.set(undefined);

    if (type === 1) {
      this.activeVibrationsOldModel.set(this.tabDonneesVibrationOldModel().filter((v: Vibration) => v.controlPointId === id)[0]);
    } else if (type === 2) {
      const vibOld: Vibration = this.tabDonneesVibrationOldModel().filter((v: Vibration) => v.controlPointId === id)[0] as Vibration;
      const newVib = new VibrationsChart(this.tabDonneesVibrationNewModel().filter((v: VibrationsChart) => v.header.controlPointId === id)[0] as VibrationsChart);
      newVib.initDataVibrationMaria(vibOld);
      this.activeVibrationsNewModel.set(newVib);
      const editNotes = new EditNotes();
      editNotes.addNote(new EditNote(newVib.header.note1));
      editNotes.addNote(new EditNote(newVib.header.note2));
      editNotes.addNote(new EditNote(newVib.header.note3));
      this.notes.set(editNotes);
      this.changeWindow(0);
      setTimeout(() => {
        this.drawingVibrations();
      }, 0);
    }
  }

  protected changeWindow(nb: number) {
    this.chartWindow.set(nb);

    if (nb == 0) {
      if (this.activeVibrationsNewModel() !== undefined) {
        setTimeout(() => {
          this.drawingVibrations();
        }, 0);
      }
    }

    if (nb == 1) {
      if (this.activeVibrationsNewModel() !== undefined) {
        setTimeout(() => {
          this.drawingFFT(this.activeVibrationsNewModel());
        }, 0);
      }
    }
  }

  private filterer(args) {
    return function (value: ControlPoint) {
      for (var i = 0; i < args.length; i++) {
        if (value.controlPointId === args[i]) {
            return true;
        }
      }
      return false;
    };
  }

  protected findEqipmentType(type: number): string {
    if (type !== 3 && type !== 5 && type !== 7) return "not set";

    if (type === 3) return "Vibracord DX";

    if (type === 5) return "Vibracord FX";

    if (type === 7) return "Vibracord Tellus";
  }

  protected findMaxAbsValue(min: number, max: number) {
    return Math.abs(max) > Math.abs(min) ? max : Math.abs(min);
  }

  private setChartDataFft(currrentVibration: VibrationsChart) {
    const result: ChartDataFft[] = [];
    const colorsArray = ['Tomato', 'MediumBlue', 'LimeGreen', 'DeepPink'];

    currrentVibration.ffts.forEach((value, index) => {
      let zeroCheck = 0;
      let chartData = new ChartDataFft();
      value.mag.forEach((v, i) => {
          if(v === 0) zeroCheck++;
          chartData.data[i] = v;
      });

      if(zeroCheck === currrentVibration.fftsHz.length) return;

      chartData.label = 'C' + (index + 1).toString();
      chartData.borderColor = colorsArray[index];
      result[index] = chartData;
    });
    this.chartDataFft.set(result);
  }

  private checkChannelData(data: VibrationsChartChannel): boolean {
    let dataNullNumber = 0;
    data.value.forEach((v, i, a) => {
      if (v === 0) {
        dataNullNumber++;
      }
    });

    return dataNullNumber === data.value.length;
  }

  private setTabControlPointsForBtns() {
    const newModelList: ControlPointVib[] = [];
    const oldModelList: ControlPointVib[] = [];

    const tabControlPoints = this.tabControlPoints() ?? [];
    const tabNew = this.tabDonneesVibrationNewModel() ?? [];
    const tabOld = this.tabDonneesVibrationOldModel() ?? [];

    const controlPointIdsFromVoibrationsNewModel = tabNew.map(v => v.header.controlPointId);
    let controlPointIdsFromVoibrationsOldModel = tabOld.map(v => v.controlPointId);
    controlPointIdsFromVoibrationsOldModel = controlPointIdsFromVoibrationsOldModel.filter(val => !controlPointIdsFromVoibrationsNewModel.includes(val));

    for (let i = 0; i < tabControlPoints.length; i++) {
      const cp = tabControlPoints[i];
      controlPointIdsFromVoibrationsNewModel.forEach((id: number) => {
        if (cp.controlPointId === id) {
          newModelList.push(new ControlPointVib(cp.controlPointId, cp.siteId, cp.numeroPoint, cp.name, cp.site, cp.x, cp.y, cp.z, VibrationType.NEW));
        }
      });
      controlPointIdsFromVoibrationsOldModel.forEach((id: number) => {
        if (cp.controlPointId === id) {
          oldModelList.push(new ControlPointVib(cp.controlPointId, cp.siteId, cp.numeroPoint, cp.name, cp.site, cp.x, cp.y, cp.z, VibrationType.OLD));
        }
      });
    }

    this.tabControlPointsVibNewModel.set(newModelList);
    this.tabControlPointsVibOldModel.set(oldModelList);
    const sorted = [...oldModelList, ...newModelList].sort((a: ControlPointVib, b: ControlPointVib) => a.controlPointId > b.controlPointId ? 1 : -1);
    this.tabControlPointsForBtn.set(sorted);
  }

  protected downloadFileVibration(){
        this.http.downloadFile('Files/' + this.activeVibrationsNewModel().id + '/Open/' + this.siteId + '?fileType=' +  DirectoryType.VIBRATIONS).subscribe((res)=>{
          if(res){
            const blob = new Blob([res.body], { type: 'base64' });
            const url = window.URL.createObjectURL(blob);
            var a = document.createElement('a');
            a.href = url;
            a.download = this.activeVibrationsNewModel().header.fileName;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
              a.remove();
            }, 100);
           }else{
           this.fonctionsService.launch_toast(false, false);
           }
        },(error: HttpErrorResponse)=>{
          if(error.status === 401){
        console.log(error.error);
          }else
            this.fonctionsService.launch_toast(false);
        })
    }

    protected saveNotes(){
     this.fonctionsService.loading_screen(true);
      const notesEdit = this.notesEdit();
      notesEdit.vibrationId = this.activeVibrationsNewModel().id;
      this.http.put('VibrationsMongo/' + this.siteId + '/EditNote', notesEdit).subscribe((res)=>{
        this.fonctionsService.launch_toast(true);
        this.fonctionsService.loading_screen(false);
        let controlPointId = this.tabControlPoints().filter(f => f.controlPointId === this.activeVibrationsNewModel().header.controlPointId)[0].controlPointId;
        let activeIndex = this.activeControlPointIndex();
        this.rechargerDonnees.emit(true)
        setTimeout(() => {
          this.changerTab(controlPointId, 2, activeIndex); 
        }, 300);
      },(error: HttpErrorResponse)=>{
        if(error.status === 401){
      console.log(error.error);
        }
        this.fonctionsService.launch_toast(false);
        this.fonctionsService.loading_screen(false);
      })
      this.modalNotes.hide();
    }

    protected openEditNotesModal(modalTemplate: TemplateRef<any>) {
      const edit = new EditNotes();
      edit.addNote(new EditNote(this.activeVibrationsNewModel().header.note1));
      edit.addNote(new EditNote(this.activeVibrationsNewModel().header.note2));
      edit.addNote(new EditNote(this.activeVibrationsNewModel().header.note3));
      edit.vibrationId = this.activeVibrationsNewModel().id;
      this.notesEdit.set(edit);
      this.modalNotes = this.modalService.show(modalTemplate);
    }

    protected closeModal(){
      this.modalNotes.hide()
    }

    
}
